import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/goals';

const Goals = ({ items, setGoalsView }) => {
  const [expanded, setExpanded] = useState('');
  const scrollToRef = (ref) => window.scrollTo(0, (ref.current.offsetTop - 70));
  const scrollRef = useRef(null);
  const toggleExpanded = () => {
    setGoalsView(`${items[0].id}-${expanded ? 'all' : 'fewer'}`);
    setExpanded(!expanded);
    if (expanded) {
      scrollToRef(scrollRef);
    }
  };

  const goalsList = items.map((item) => (
    <li key={item.id}>
      <span dangerouslySetInnerHTML={{ __html: item.content }} />
    </li>
  ));

  const modifiedGoalsList = goalsList.slice(0, 2);

  return (
    <div className="goals" ref={scrollRef}>
      <div className="title">
        <h2>
          {Locale.title}
        </h2>
      </div>
      <div className="goals-list">
        <ul>
          {goalsList}
        </ul>
      </div>
      <div className={`goals-list-mobile ${expanded ? 'expanded' : ''}`}>
        <ul>
          {expanded ? goalsList : modifiedGoalsList}
        </ul>
        <button
          type="button"
          aria-label="show/hide goals"
          onClick={toggleExpanded}
        >
          { expanded ? 'SHOW FEWER GOALS' : 'SHOW ALL GOALS' }
        </button>
      </div>
    </div>
  );
};

Goals.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  setGoalsView: PropTypes.func.isRequired
};

export default Goals;
